// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jRKS","colMin":"styles_colMin__1bnF-"};